// extracted by mini-css-extract-plugin
export default {"pageContainer":"Motivos_pageContainer__4lta9","pageTitle":"Motivos_pageTitle__PJz4W"};